import axios from "axios";
import store from "./store";

const config = {
  redirectUri: "https://blog.demo.suzumuchi.dk/callback",
  authUri: "https://oauth.suzumuchi.dk",
};

function generateState() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default {
    login() {
        const state = generateState();
        sessionStorage.setItem("oauth_state", state);
        const urlParams = new URLSearchParams(window.location.search);
        sessionStorage.setItem("market", urlParams.get("market"));
        sessionStorage.setItem("eventId", urlParams.get("eventId"));
        window.location.href = `${config.authUri}/auth?state=${state}&redirect_uri=${encodeURIComponent(config.redirectUri)}`; // Redirects user to Azure AD Login
    },
    logout() {
        sessionStorage.removeItem("oauth_state");
        sessionStorage.removeItem("market");
        sessionStorage.removeItem("eventId");
        sessionStorage.removeItem("access_token");
        sessionStorage.removeItem("refresh_token");
        store.commit("SET_AUTHENTICATED", false);
        window.location.reload();
    },

    async handleCallback() {
        const queryParams = new URLSearchParams(window.location.search);// Get the token from URL fragment
        const code = queryParams.get("code");
        const returnedState = queryParams.get("state");

        const storedState = sessionStorage.getItem("oauth_state");

        if (returnedState !== storedState) {
            console.error(`State mismatch! Possible CSRF attack.${returnedState}, ${storedState}`);
            return;
        }

        if (!code) {
            console.error("Authenticated failed");
        }

        axios.post("https://oauth.suzumuchi.dk/token",
            new URLSearchParams({
                grant_type: "authorization_code",
                code: code
            }),
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                }
            }
        )
            .then(response => {
                console.log("Access Token:", response.data.access_token);
                this.setToken(response.data.access_token)
                this.setRefreshToken(response.data.refresh_token)
                store.commit("SET_AUTHENTICATED", true);
            })
            .catch(error => {
                console.error("Error exchanging code for token:", error.response?.data || error);
            });


        const params = ["market", "eventId"]; // List of parameters to check
        const url = new URL("/", window.location.origin); // Base URL for redirection

        params.forEach(param => {
            const value = sessionStorage.getItem(param);
            if (value !== "null") {
                url.searchParams.set(param, value); // Add parameter if it exists
            }
        });

        // Redirect to the updated URL
        window.history.replaceState({}, document.title, url.toString());

    },
    getToken() {
        return sessionStorage.getItem("access_token");
    },
    setToken(token){
        sessionStorage.setItem("access_token", token);
    },
    getRefreshToken() {
        return sessionStorage.getItem("refresh_token");
    },
    setRefreshToken(token) {
        sessionStorage.setItem("refresh_token", token);
    },
    async refreshToken(){
        const response = await axios.post("https://oauth.suzumuchi.dk/token",
      new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: this.getRefreshToken()
      }), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
          )
        this.setRefreshToken(response.data.refresh_token)
        this.setToken(response.data.access_token)
        store.commit("SET_AUTHENTICATED", true);
        return this.getToken()
    }
};